export const profileProps = {
  basename: "/plataforma/dados-cadastrais",
};
